export default __webpack_public_path__ + "static/media/crossCircle.aaf060b6.svg";